// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__CabYF","item":"PaymentsMobile_item__1p6O-","label":"PaymentsMobile_label__11uR4","amount":"PaymentsMobile_amount__3Wrdd"};